export default __webpack_public_path__ + "static/media/done_icon.13863814.svg";